import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";
import "./AddProducts.css";
import DashSidebar from "./DashSidebar";

const AddJewlry = () => {
  const [products, setProducts] = useState([]);

  const { token } = useContext(AuthContext);

  const location = useLocation();

  const [price, setPrice] = useState("");
  const [diamondSku, setDiamondSku] = useState("");
  const [productName, setProductName] = useState("");
  const [image, setImage] = useState([]);
  const [carat, setCarat] = useState("");
  const [size, setSize] = useState("");
  const [getMetal, setMetal] = useState([]);
  const [getProductType, setProductType] = useState([]);
  const [getProductSetting, setProductSetting] = useState([]);
  const [getStyle, setStyle] = useState([]);
  const [getCollection, setCollection] = useState([]);

  // Add separate state variables to track the selected values
  const [selectedMetal, setSelectedMetal] = useState(
    getMetal.length > 0 ? getMetal[0].metal_id : "6"
  );
  const [selectedProductType, setSelectedProductType] = useState(
    getProductType.length > 0 ? getProductType[0].product_type_id : "3"
  );
  const [selectedProductSetting, setSelectedProductSetting] = useState(
    getProductSetting.length > 0
      ? getProductSetting[0].product_settings_id
      : "4"
  );
  const [selectedStyle, setSelectedStyle] = useState(
    getStyle.length > 0 ? getStyle[0].style_id : "4"
  );
  const [selectedCollection, setSelectedCollection] = useState(
    getCollection.length > 0 ? getCollection[0].collection_id : "4"
  );

  const [skuError, setSkuError] = useState("");

  // Determine the active class based on the current route
  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  useEffect(() => {
    fetchProducts();
    fetchJeweleryData();
  }, []);

  const fetchProducts = async () => {
    const allData = {
      category: ["jewelry"],
    };
    try {
      const response = await axios.post(`/product_read`, allData);
      const sortedProducts = response.data.data.sort(
        (a, b) =>
          new Date(b.product_created_on) - new Date(a.product_created_on)
      );
      setProducts(sortedProducts);
    } catch (error) {
      console.error(error.response.data);
      alert("Failed to fetch products.");
    }
  };

  const fetchJeweleryData = async () => {
    try {
      const metalData = await axios.get("/metal_read");
      const metalProduct = metalData.data.data;
      setMetal(metalProduct);

      const productTypeData = await axios.get("/product_type_read");
      const productTypeProduct = productTypeData.data.data;
      setProductType(productTypeProduct);

      const productSettingsData = await axios.get("/product_settings_read");
      const productSettingsProduct = productSettingsData.data.data;
      setProductSetting(productSettingsProduct);

      const StyleData = await axios.get("/style_read");
      const StyleProduct = StyleData.data.data;
      setStyle(StyleProduct);

      const CollectionData = await axios.get("/collection_read");
      const CollectionProduct = CollectionData.data.data;
      setCollection(CollectionProduct);
    } catch (error) {
      console.error(error.response.data.data);
      alert("Failed to fetch products.");
    }
  };

  const ListMetal =
    getMetal.length > 0 ? (
      getMetal.map((metal) => (
        <option key={metal.metal_id} value={metal.metal_id}>
          {metal.metal_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListProductType =
    getProductType.length > 0 ? (
      getProductType.map((product_type) => (
        <option
          key={product_type.product_type_id}
          value={product_type.product_type_id}
        >
          {product_type.product_type_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListProductSetting =
    getProductSetting.length > 0 ? (
      getProductSetting.map((product_settings) => (
        <option
          key={product_settings.product_settings_id}
          value={product_settings.product_settings_id}
        >
          {product_settings.product_settings_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListStyle =
    getStyle.length > 0 ? (
      getStyle.map((style) => (
        <option key={style.style_id} value={style.style_id}>
          {style.style_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const ListCollection =
    getCollection.length > 0 ? (
      getCollection.map((collection) => (
        <option key={collection.collection_id} value={collection.collection_id}>
          {collection.collection_name}
        </option>
      ))
    ) : (
      <option value="">Loading...</option>
    );

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Check for SKU duplication
    const isSkuDuplicate = products.some(
      (product) => product.product_sku === diamondSku
    );

    if (isSkuDuplicate) {
      setSkuError("SKU already exists. Please enter a unique SKU.");
      return;
    }

    try {
      // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2ODgzNjkzNzAsImVtcF9pZCI6M30.QUr0D66KGgSndZ3HwmrnQUXNaFic0Qtzb4Q0y6-Kl68';
      const token = localStorage.getItem("token");
      // console.log('̥', token);

      const formData = new FormData();
      formData.append("shape_id_fk", "14");
      formData.append("color_id_fk", "7");
      formData.append("clarity_id_fk", "8");
      formData.append("cut_id_fk", "6");
      formData.append("carat", carat);
      formData.append("price", price);
      formData.append("size", size);
      formData.append("product_sku", diamondSku);
      formData.append("collection_id_fk", selectedCollection);

      for (let i = 0; i < image.length; i++) {
        formData.append("product_image", image[i]);
      }

      formData.append("product_name", productName);
      formData.append("category_id_fk", "6");
      formData.append("stone_type", "0");
      formData.append("matching_band", "0");
      formData.append("in_stock", 1);
      formData.append("metal_id_fk", selectedMetal);
      formData.append("product_type_id_fk", selectedProductType);
      formData.append("settings_id_fk", selectedProductSetting);
      formData.append("style_id_fk", selectedStyle);

      setSkuError("");

      await axios.post("/product_insert", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `multipart/form-data`,
        },
      });

      // console.log(response.data);
      alert("Product Uploaded Sucessfully!!!!!");
    } catch (error) {
      // console.error(error.response.data);
      alert("Add Data First.......");
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="addproductModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addproductModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-scrollable modal-xl"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addproductModalLabel">
                <b>Add Jewellery</b>
              </h5>
              <button
                type="button"
                className="close btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleFormSubmit} className="py-3 m-0 w-100">
                <div className="row">
                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Select Metal
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={selectedMetal}
                      onChange={(e) => setSelectedMetal(e.target.value)}
                    >
                      {ListMetal}
                    </select>
                  </div>
                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Select Product Type
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={selectedProductType}
                      onChange={(e) => setSelectedProductType(e.target.value)}
                    >
                      {ListProductType}
                    </select>
                  </div>
                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Select Product Settings
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={selectedProductSetting}
                      onChange={(e) =>
                        setSelectedProductSetting(e.target.value)
                      }
                    >
                      {ListProductSetting}
                    </select>
                  </div>
                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Select Style
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={selectedStyle}
                      onChange={(e) => setSelectedStyle(e.target.value)}
                    >
                      {ListStyle}
                    </select>
                  </div>

                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Collection
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={selectedCollection}
                      onChange={(e) => setSelectedCollection(e.target.value)}
                    >
                      {ListCollection}
                    </select>
                  </div>

                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Carat (K)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="carat"
                      onChange={(e) => setCarat(e.target.value)}
                      id=""
                      placeholder="Enter Carat"
                    />
                  </div>

                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Price
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="price"
                      onChange={(e) => setPrice(e.target.value)}
                      id=""
                      placeholder="Enter Price"
                    />
                  </div>

                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Product SKU
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="product-SKU"
                      onChange={(e) => setDiamondSku(e.target.value)}
                      id=""
                      placeholder="Enter Diamond SKU"
                    />
                    {skuError && (
                      <div className="mt-2 alert alert-danger">{skuError}</div>
                    )}
                  </div>

                  <div className="col-sm-3 mb-4">
                    <label htmlFor="" className="form-label">
                      Product Size
                    </label>
                    <input
                      className="form-control m-0"
                      name="product_size"
                      type="text"
                      placeholder="Enter Product Size"
                      onChange={(e) => setSize(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-6 mb-4">
                    <label htmlFor="" className="form-label">
                      Product Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="product-name"
                      onChange={(e) => setProductName(e.target.value)}
                      id=""
                      placeholder="Enter Diamond Name"
                    />
                  </div>

                  <div className="col-sm-12 my-4">
                    <label htmlFor="" className="form-label">
                      Product Images
                    </label>
                    <input
                      className="form-control m-0"
                      name="product_image"
                      accept="image/*"
                      type="file"
                      multiple
                      onChange={(e) => setImage(e.target.files)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="text-right">
                      <button type="submit" className="btn btn__primary mt-3">
                        Add Jewellery
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddJewlry;
